import { motion } from "framer-motion";

export default function CTASection() {
  return (
    <section
      data-testid="cta-section"
      className="py-24 md:py-32 bg-black relative overflow-hidden"
    >
      {/* Gold glow accent */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-gradient-to-br from-[#B76E79]/10 to-transparent blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] bg-clip-text text-transparent bg-gradient-to-r from-[#B76E79] to-[#D68B8B] mb-6">
            Randevu
          </p>
          <h2
            data-testid="cta-headline"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-white mb-6 max-w-2xl mx-auto leading-tight"
          >
            Kendinize Hak Ettiğiniz Bakımı Sunun
          </h2>
          <p className="text-base text-white/70 mb-10 max-w-lg mx-auto leading-relaxed">
            Uzman ekibimizle tanışın, size özel bakım planınızı oluşturalım.
          </p>
          <a
            href="https://wa.me/905441199544?text=Merhaba%2C%20randevu%20almak%20istiyorum."
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-button"
            className="inline-flex items-center justify-center gold-bg text-black hover:opacity-90 transition-opacity duration-300 px-10 py-4 uppercase tracking-widest text-sm font-semibold"
          >
            Hemen Randevu Al
          </a>
        </motion.div>
      </div>
    </section>
  );
}
